"use strict";

/**
 * Lowercase and remove spaces in the email
 * @param {string} email - The email address to format
 */
exports.formatEmail = function (email) {
  return email.toLowerCase().replace(/\s/g, '');
};